export const BASE_URL = process.env.REACT_APP_API_BASE_URL
    || 'https://zashani-back-613459352835.europe-west1.run.app/api';
